<template>
    <a-modal
        :title="title[0]"
        :visible="visible"
        :width="960"
        wrapClassName="contacts_select"
        @ok="toCheck"
        @cancel="toCancel"
    >
        <div class="modal_wrapper">
            <div class="cont cont_left">
                <a-input-search
                    allowClear
                    placeholder="搜索"
                    @search="toSearch"
                    @change="searchChange"
                    style="margin-bottom:8px;"
                />
                <a-tree
                    class="contacts_tree"
                    :tree-data="dataList"
                    :load-data="get"
                    :loaded-keys="selectKey"
                    :selected-keys="selectKeys"
                    :default-selected-keys="selectKey"
                    :multiple="multiple"
                    :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
                    blockNode
                    @select="toSelectTree"
                >
                    <template slot="custom" slot-scope="item">
                        <a-space>
                            <a-icon :type="item.type === 'departmentName' ? 'folder' : 'user'" />
                            <openData :type="item.type" :openid="item.name"></openData>
                            <a-icon type="check" v-if="item.selected" />
                        </a-space>
                    </template>
                </a-tree>
            </div>
            <div class="cont cont_right">
                <p>{{ title[1] }}</p>
                <a-tree
                    :tree-data="selectDataList"
                    :replaceFields="{ children: 'children', title: 'name', key: 'id' }"
                    blockNode
                    @select="toDeleteTree"
                >
                    <template slot="custom" slot-scope="item">
                        <a-space style="width: 100%; justify-content: space-between;">
                            <a-space>
                                <a-icon :type="item.type === 'userName' ? 'user' : 'folder'" />
                                <openData :type="item.type" :openid="item.name"></openData>
                            </a-space>
                            <a-icon type="close" />
                        </a-space>
                    </template>
                </a-tree>
            </div>
        </div>
    </a-modal>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import openData from '@/components/group/openData';
export default {
    components: {
        openData
    },
    props: {
        selectKey: {
            type: Array,
            default: () => []
        },
        title: {
            type: Array,
            default: ['选择客户', '已选择的客户']
        },
        backFunctionName: {
            type: String,
            default: ''
        },
        backFunctionData: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            visible: false,
            multiple: true,
            selectable: true,
            keywords: '',
            selectKeys: [],
            dataList: [],
            selectDataList: []
        };
    },
    methods: {
        open() {
            if (this.type !== 'multi') this.selectable = false;
            if (this.type === 'single') this.multiple = false;
            this.selectKeys = [...this.selectKey];
            if (this.selectKeys.length > 0) {
                this.selectDataList = this.selectKeys.map((item) => {
                    const row = {
                        id: item,
                        name: item,
                        type: typeof item === 'number' ? 'departmentName' : 'userName',
                        scopedSlots: { title: 'custom' }
                    };
                    return row;
                });
            }
            this.init();
            this.visible = true;
        },
        toCheck() {
            this.visible = false;
            const backData = {
                status: true,
                dataName: this.backFunctionData ? this.selectKeys : {}
            };
            this.$emit('change', this.selectKeys);
            this.$emit(this.backFunctionName, this.backFunctionData ? backData : '');
        },
        toCancel() {
            this.visible = false;
            this.selectDataList = [];
        },
        // 初始数据
        async init() {
            try {
                const res = await api.getDepartment();
                if (res.code !== 0) return;
                const departmentList = res.department.map((item) => {
                    let row = item;
                    row.type = 'departmentName';
                    row.selectable = this.selectable;
                    row.children = [];
                    row.scopedSlots = { title: 'custom' };
                    return row;
                });
                this.dataList = departmentList;
            } catch (err) {
                console.log(err);
            }
        },
        // 追加数据
        async get(e) {
            try {
                const res = await api.getDepartment({ deptId: e.dataRef.id });
                if (res.code !== 0) return;
                const departmentList = res.department.map((item) => {
                    let row = item;
                    row.type = 'departmentName';
                    row.selectable = this.selectable;
                    row.children = [];
                    row.scopedSlots = { title: 'custom' };
                    return row;
                });
                const userList = res.user.map((item) => {
                    let row = item;
                    row.id = item.userid;
                    row.type = 'userName';
                    row.isLeaf = true;
                    row.scopedSlots = { title: 'custom' };
                    return row;
                });
                if (!departmentList.length && !userList.length) e.dataRef.isLeaf = true;
                e.dataRef.children = [...departmentList, ...userList];
            } catch (err) {
                console.log(err);
            }
        },
        // 搜索
        async toSearch() {
            try {
                const res = await api.getDepartmentSearch({ keywords: this.keywords });
                if (res.code !== 0) return;
                const departmentList = res.deptId.map((item, index) => {
                    return {
                        id: index,
                        name: item,
                        type: 'departmentName',
                        selectable: this.selectable,
                        scopedSlots: { title: 'custom' }
                    };
                });
                const userList = res.userId.map((item) => {
                    return {
                        id: item,
                        name: item,
                        type: 'userName',
                        isLeaf: true,
                        scopedSlots: { title: 'custom' }
                    };
                });
                this.dataList = [...departmentList, ...userList];
            } catch (err) {
                console.log(err);
            }
        },
        searchChange(e) {
            if (e.target.value) {
                this.keywords = e.target.value;
            } else {
                this.keywords = '';
                this.init();
            }
        },
        // 选择
        toSelectTree(selectedKeys, e) {
            this.selectDataList = e.selectedNodes.map((item) => {
                const selectItem = {
                    id: item.data.props.dataRef.id,
                    name: item.data.props.dataRef.name,
                    type: item.data.props.dataRef.type,
                    scopedSlots: item.data.props.dataRef.scopedSlots
                };
                return selectItem;
            });
            this.selectKeys = selectedKeys;
        },
        toDeleteTree(selectedKeys, e) {
            const deleteItem = {
                id: e.selectedNodes[0].data.props.dataRef.id,
                name: e.selectedNodes[0].data.props.dataRef.name,
                type: e.selectedNodes[0].data.props.dataRef.type,
                scopedSlots: e.selectedNodes[0].data.props.dataRef.scopedSlots
            };
            this.selectDataList = _.differenceBy(this.selectDataList, [deleteItem], 'id');
            this.selectKeys = _.map(this.selectDataList, 'id');
        }
    }
};
</script>

<style>
.contacts_select .modal_wrapper {
    font-size: 0;
    margin: 0 -15px;
}
.contacts_select .cont {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    padding: 0 15px;
}
.contacts_select .cont_left {
    border-right: 1px solid #e8e8e8;
}
.contacts_select .cont_left .contacts_tree {
    height: 50vh;
    overflow-y: auto;
}
.contacts_select .cont_right {
    font-size: 16px;
    line-height: 32px;
    margin-bottom: 8px;
}
</style>
